var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-0 m-0"},_vm._l((_vm.messages),function(message,key){return _c('div',{key:key,staticClass:"center-text"},[_c('h6',{class:[
        'text-center noBorderRadius inline-display mb-0',
        message.class ]},[_vm._v(" "+_vm._s(message.text)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }